// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"1cb001ff","52":"3b42c3d4","139":"f542fd64","186":"3ad47ab3","520":"d97c2ef6","602":"7d498731","634":"cc1f5d61","702":"913ba795","756":"85a12039","809":"eabd0fa7","911":"601b6ab1","930":"24c32ef4"}[chunkId] + ".chunk.js";
};